module.exports = __webpack_public_path__ + "img/5_SENSAR.79a1e319.jpg";